{
  "name": "trace-mcp",
  "version": "3.23.0",
  "mcpName": "io.github.nikolai-vysotskyi/trace-mcp",
  "description": "Framework-aware code intelligence MCP server — 87 framework integrations, 81 languages, 70.5% fewer input tokens to review a pull request, comprehension at parity",
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "trace": "dist/cli.js",
    "trace-mcp": "dist/cli.js"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:recall": "vitest run tests/recall-harness/recall.test.ts",
    "test:recall:report": "tsx tests/recall-harness/runner.ts",
    "typecheck": "tsc --noEmit",
    "lint": "tsc --noEmit",
    "format": "biome format --write",
    "format:check": "biome format",
    "biome:ci": "biome ci",
    "serve": "tsx src/cli.ts serve",
    "check:remote-claims": "node scripts/check-remote-claims.mjs",
    "count:tools": "node scripts/count-advertised-tools.mjs",
    "record:wire-fixtures": "tsx scripts/record-wire-fixtures.ts",
    "replay:check": "tsx scripts/replay-eval.ts",
    "replay:update-baseline": "tsx scripts/replay-eval.ts --update-baseline",
    "bench:state-replay": "tsx scripts/state-trace-replay.ts",
    "bench:state-recall": "tsx scripts/bench-state-recall.ts",
    "bench:index-throughput": "tsx scripts/bench-index-throughput.ts --json docs/perf/index-throughput.json",
    "bench:session-scaling": "tsx scripts/bench-session-scaling.ts",
    "postinstall": "node scripts/preflight-native.mjs && node scripts/postinstall-app.mjs && node scripts/postinstall-control-plane.mjs",
    "prepublishOnly": "pnpm run build",
    "prepare": "simple-git-hooks",
    "docs:sitemap": "node scripts/gen-sitemap.mjs && node scripts/gen-llms-full.mjs",
    "docs:language-matrix": "tsx scripts/language-matrix.ts",
    "docs:tools-index": "tsx scripts/tools-index.ts",
    "docs:config-index": "tsx scripts/config-index.ts",
    "gen:tz-country": "node scripts/gen-tz-country.mjs"
  },
  "simple-git-hooks": {
    "pre-commit": "pnpm exec lint-staged"
  },
  "lint-staged": {
    "*.{ts,tsx,js,jsx,mjs,cjs,json,jsonc,css}": [
      "biome check --write --no-errors-on-unmatched"
    ]
  },
  "engines": {
    "node": ">=22.0.0"
  },
  "packageManager": "pnpm@10.33.0",
  "license": "MIT",
  "author": "Nikolai Vysotskyi",
  "repository": {
    "type": "git",
    "url": "https://github.com/nikolai-vysotskyi/trace-mcp"
  },
  "homepage": "https://trace-mcp.com",
  "keywords": [
    "mcp-server",
    "claude-code",
    "cursor",
    "ai-agents",
    "code-graph",
    "dependency-graph",
    "token-optimization",
    "mcp",
    "code-intelligence",
    "laravel",
    "vue",
    "nuxt",
    "inertia",
    "framework-aware",
    "static-analysis"
  ],
  "files": [
    "dist",
    "hooks",
    "scripts",
    ".claude-plugin",
    ".codex-plugin",
    "LICENSE",
    "README.md"
  ],
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "dependencies": {
    "@ast-grep/napi": "^0.45.0",
    "@clack/prompts": "^1.2.0",
    "@modelcontextprotocol/sdk": "^1.29.0",
    "@parcel/watcher": "^2.5.6",
    "@toon-format/toon": "4.1.1",
    "@vue/compiler-sfc": "^3.5.32",
    "better-sqlite3": "^13.0.3",
    "commander": "^14.0.3",
    "cosmiconfig": "^10.0.0",
    "fast-glob": "^3.3.3",
    "fastest-levenshtein": "^1.0.16",
    "jsonc-parser": "^3.3.1",
    "neverthrow": "^8.2.0",
    "oxc-resolver": "^11.19.1",
    "picomatch": "^4.0.4",
    "pino": "^10.3.1",
    "tree-sitter-wasm": "^1.1.6",
    "web-tree-sitter": "^0.26.13",
    "xxhash-wasm": "^1.1.0",
    "yaml": "^2.8.3",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.10",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/react": "^16.3.2",
    "@types/better-sqlite3": "^9.6.0",
    "@types/node": "^22.13.0",
    "@types/picomatch": "^4.0.3",
    "fast-check": "^4.6.0",
    "gpt-tokenizer": "^4.0.0",
    "jsdom": "^30.0.1",
    "lint-staged": "17.3.0",
    "simple-git-hooks": "2.13.1",
    "tsup": "^8.4.0",
    "tsx": "^4.19.0",
    "tweakcc": "4.3.3",
    "typescript": "^6.0.3",
    "vite": "^8.1.3",
    "vitest": "^4.1.4"
  },
  "optionalDependencies": {
    "@huggingface/transformers": "^4.0.1",
    "sqlite-vec": "^0.1.9"
  },
  "overrides": {
    "protobufjs": ">=8.6.6",
    "qs": ">=6.16.0",
    "hono": ">=4.12.25",
    "@hono/node-server": ">=2.0.5",
    "js-yaml": "^4.3.1",
    "vite": "$vite",
    "undici": ">=8.9.0",
    "esbuild": ">=0.28.1",
    "sharp": ">=0.35.0",
    "fast-uri": ">=4.1.3",
    "adm-zip": ">=0.6.0",
    "body-parser": ">=2.3.0",
    "nanoid": ">=3.3.17"
  },
  "pnpm": {
    "overrides": {
      "zod": "4.3.6",
      "qs": ">=6.16.0",
      "protobufjs@<8.6.6": ">=8.6.6",
      "hono": ">=4.12.25",
      "@hono/node-server": ">=2.0.5",
      "js-yaml": "^4.3.1",
      "undici": ">=8.9.0",
      "vite": ">=8.0.16",
      "esbuild": ">=0.28.1",
      "sharp": ">=0.35.0",
      "fast-uri": ">=4.1.3",
      "adm-zip": ">=0.6.0",
      "body-parser": ">=2.3.0",
      "postcss": ">=8.5.23",
      "nanoid": ">=3.3.17"
    },
    "onlyBuiltDependencies": [
      "@parcel/watcher",
      "esbuild",
      "simple-git-hooks"
    ],
    "supportedArchitectures": {
      "os": [
        "current"
      ],
      "cpu": [
        "x64",
        "arm64"
      ]
    }
  }
}
